import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, Select, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section9({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-178">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-179">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-180">
          <span className="text-dorado mr-2" data-id="element-181">Sección 09 ·</span>
          Siguiente Paso
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-182">
          Estamos listos para comenzar. Afina los últimos detalles.
        </p>
      </div>

      <FormField label="¿Cuándo te gustaría iniciar tu programa de 90 días?" name="inicio" error={errors.inicio} required data-id="element-183">
        <div className="space-y-3 mt-2" data-id="element-184">
          {['Esta misma semana', 'En las próximas 2 semanas', 'Este mes', 'Más adelante (solo busco información por ahora)'].map(option => <label key={option} className="flex items-center space-x-3 p-3 border-2 border-plateado rounded-xl cursor-pointer hover:border-dorado transition-colors bg-white" data-id="element-185">
              <input type="radio" name="inicio" value={option} checked={data.inicio === option} onChange={e => onChange('inicio', e.target.value)} className="w-5 h-5 text-dorado focus:ring-dorado" data-id="element-186" />
              <span className="text-texto-oscuro" data-id="element-187">{option}</span>
            </label>)}
        </div>
      </FormField>

      <FormField label="Presupuesto mensual disponible para tu transformación" name="presupuesto" error={errors.presupuesto} required data-id="element-188">
        <Select id="presupuesto" value={data.presupuesto} onChange={e => onChange('presupuesto', e.target.value)} error={!!errors.presupuesto} data-id="element-189">
          <option value="" data-id="element-190">Selecciona un rango...</option>
          <option value="bajo" data-id="element-191">
            $50 - $100 USD (Programas grupales o autodirigidos)
          </option>
          <option value="medio" data-id="element-192">
            $100 - $250 USD (Acompañamiento intermedio)
          </option>
          <option value="alto" data-id="element-193">$250+ USD (Coaching 1:1 personalizado)</option>
        </Select>
      </FormField>

      <FormField label="¿Hay algo más que debamos saber sobre ti?" name="comentarios" error={errors.comentarios} description="(Opcional) Cualquier detalle adicional que consideres importante." data-id="element-194">
        <TextArea id="comentarios" value={data.comentarios} onChange={e => onChange('comentarios', e.target.value)} error={!!errors.comentarios} placeholder="Escribe tus comentarios aquí..." className="min-h-[100px]" data-id="element-195" />
      </FormField>

      <div className="mt-8 p-4 bg-azul-profundo/5 rounded-xl border border-azul-profundo/10" data-id="element-196">
        <label className="flex items-start space-x-3 cursor-pointer" data-id="element-197">
          <input type="checkbox" checked={data.consentimiento || false} onChange={e => onChange('consentimiento', e.target.checked)} className="w-5 h-5 mt-0.5 text-dorado focus:ring-dorado rounded" data-id="element-198" />
          <span className={`text-sm ${errors.consentimiento ? 'text-red-600 font-medium' : 'text-gray-700'}`} data-id="element-199">
            He leído la nota médica y entiendo que este diagnóstico y programa
            no sustituyen una consulta médica profesional. Confirmo que la
            información proporcionada es verdadera.
          </span>
        </label>
      </div>
    </div>;
}